var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSokrat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 60,
    viewBox: "0 0 160 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.686 28.4291H101.101V25.894H109.557C112.957 25.894 111.916 28.4291 110.686 28.4291ZM100.813 28.7178V30.412H98.843V35.2062H101.101V30.6882H107.863C108.641 30.6882 109.005 31.5667 109.783 32.7213C110.41 33.6374 110.937 34.3277 111.527 35.2062H114.061C112.932 33.0726 111.313 31.7549 110.962 30.412C115.015 30.0732 115.228 23.9237 110.398 23.9237H98.8304V28.7178H100.813Z",
    fill: "#221E1F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.0396 33.2232C71.2795 33.2232 67.2774 33.7253 67.2774 29.5586C67.2774 25.392 71.2795 25.894 74.0396 25.894C79.472 25.894 79.472 33.2232 74.0396 33.2232ZM65.0065 29.5586C65.0065 32.4326 67.5031 35.2062 70.3636 35.2062H74.8801C81.9058 35.2062 81.9058 23.9237 74.8801 23.9237H70.3636C67.591 23.9237 65.0065 26.7976 65.0065 29.5712V29.5586Z",
    fill: "#221E1F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7883 25.894H47.8186C47.8186 31.5039 51.3691 29.3328 60.7911 31.5416C60.7409 33.8884 58.9845 33.2358 54.5934 33.2358C46.5264 33.2358 52.6614 32.1063 47.8312 32.1063C47.919 36.1224 52.1093 35.2062 54.882 35.2062C58.4952 35.2062 61.9579 35.909 62.8863 33.035C64.304 28.6927 56.8893 28.6676 52.9123 28.1405C50.6791 27.8393 49.8009 28.3287 49.8009 25.894H49.7883Z",
    fill: "#221E1F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.499 26.1701C125.302 27.7012 126.105 29.2825 127.034 30.6756H121.676C122.203 29.885 122.517 29.2323 123.031 28.3664C123.546 27.5004 123.784 26.6847 124.499 26.1701ZM116.896 35.1936H119.155C121.3 31.9808 118.515 32.6585 127.611 32.6585C128.439 32.6585 128.865 33.8382 129.58 35.1936H131.839C131.575 34.0766 129.405 30.5124 128.69 29.3202C125.566 24.1119 126.657 23.9111 123.671 23.9111C122.831 23.9111 122.856 24.388 122.53 25.0281L120.096 29.3579C119.519 30.3744 119.079 31.2404 118.477 32.2569C118 33.0476 117.122 34.3904 116.909 35.1936H116.896Z",
    fill: "#221E1F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.207 29.5586C82.207 32.5706 84.6159 35.2061 87.5642 35.2061H96.3087V33.2358C88.9818 33.2358 84.4652 34.4155 84.4652 29.0064C84.4652 24.8398 92.0932 25.9066 96.3087 25.9066V23.9362C91.5663 23.9362 86.0962 23.1079 83.863 25.5803C82.8217 26.7349 82.2196 27.9271 82.2196 29.5712L82.207 29.5586Z",
    fill: "#221E1F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7883 25.894L60.2266 25.8941C60.6782 26.5592 60.5652 26.1827 60.7911 27.0235H63.0494C62.7734 23.635 59.9756 23.9111 57.9682 23.9237C55.2458 23.9362 52.5108 23.9237 49.7883 23.9237V25.894Z",
    fill: "#221E1F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.859 25.894H138.601V35.1936H140.859V25.894Z",
    fill: "#221E1F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.601 25.894L138.601 23.9111H131.839V25.894L138.601 25.894Z",
    fill: "#221E1F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.859 25.894L147.622 25.894V23.9111H140.859L140.859 25.894Z",
    fill: "#221E1F"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.4587 30.6882H35.6867V28.4291H31.4587V30.6882Z",
    fill: "#5D56A5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 30.6882H16.228V28.4291H12V30.6882Z",
    fill: "#5D56A5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7142 41.4059H24.9724V37.1765H22.7142V41.4059Z",
    fill: "#5D56A5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7601 21.878C15.5003 22.9448 16.7298 23.9738 17.6457 24.7645L19.1135 23.4216C18.3482 22.3172 17.1689 21.238 16.5165 20.2591L14.7601 21.8906V21.878Z",
    fill: "#5D56A5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7142 21.9407H24.9724V18H22.7142V21.9407Z",
    fill: "#5D56A5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6359 23.3589L29.9783 24.8272C30.9568 23.9738 32.1864 22.9447 32.8639 21.9407L31.5215 20.4598C30.4551 21.2003 29.4263 22.4302 28.6359 23.3463V23.3589Z",
    fill: "#5D56A5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8228 37.1765L16.1653 38.6449L19.1135 35.8337L17.6958 34.29C16.7172 35.1434 15.4878 36.1725 14.8103 37.1765H14.8228Z",
    fill: "#5D56A5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.5731 35.6956L31.396 38.6449L32.9266 37.2393L30.1163 34.29L28.5731 35.6956Z",
    fill: "#5D56A5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7142 30.6882H24.9724V28.4291H22.7142V30.6882Z",
    fill: "#5D56A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSokrat);
export default __webpack_public_path__ + "static/media/sokrat.f27e0ccf988247bcce5c7fddc1bed5cc.svg";
export { ForwardRef as ReactComponent };